export const MENU = [
  { name: 'avatar', url: 'avatar', icon: '' },
  { name: 'button', url: 'button', icon: '' },
  { name: 'breadcrumb', url: 'breadcrumb', icon: '' },
  { name: 'card', url: 'card', icon: '' },
  { name: 'checkbox', url: 'checkbox', icon: '' },
  { name: 'chip', url: 'chip', icon: '' },
  { name: 'datepicker', url: 'datepicker', icon: '' },
  { name: 'expansion-panel', url: 'expansion-panel', icon: '' },
  { name: 'footer', url: 'footer', icon: '' },
  { name: 'header', url: 'header', icon: '' },
  { name: 'icon', url: 'icon', icon: '' },
  { name: 'input', url: 'input', icon: '' },
  { name: 'load-micro', url: 'load-micro', icon: '' },
  { name: 'menu', url: 'menu', icon: '' },
  { name: 'modal', url: 'modal', icon: '' },
  { name: 'navbar', url: 'navbar', icon: '' },
  { name: 'password level', url: 'password-level', icon: '' },
  { name: 'radio-button', url: 'radio-button', icon: '' },
  { name: 'required message', url: 'required-message', icon: '' },
  { name: 'select', url: 'select', icon: '' },
  { name: 'sidenav', url: 'sidenav', icon: '' },
  { name: 'tab', url: 'tab', icon: '' },
  { name: 'text', url: 'text', icon: '' },
  { name: 'textarea', url: 'textarea', icon: '' },
  { name: 'typography', url: 'typography', icon: '' },
  { name: 'switch', url: 'switch', icon: '' },
];
